import { createContext, useContext, useState } from "react";
import AssetHandleSidebar from "../components/AssetHandleSidebar";

interface IAssetSidebarContext {
    openAssetSidebar: () => void;
    closeAssetSidebar: () => void;
    isOpen: boolean;
}

const AssetSidebarContext = createContext<IAssetSidebarContext | null>(null);

interface IAssetSidebarProviderProps {
    children: React.ReactNode;
}

export const AssetSidebarProvider = ({ children }: IAssetSidebarProviderProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const openAssetSidebar = () => setIsOpen(true);
    const closeAssetSidebar = () => setIsOpen(false);

    return (
        <AssetSidebarContext.Provider value={{ openAssetSidebar, closeAssetSidebar, isOpen }}>
            {children}
            <AssetHandleSidebar
                isOpen={isOpen}
                toggle={(open) => setIsOpen(open)}
            />
        </AssetSidebarContext.Provider>
    );
};

export const useAssetSidebarContext = () => {
    const context = useContext(AssetSidebarContext);
    if (!context) {
        throw new Error("useAssetSidebarContext must be used within AssetSidebarProvider");
    }
    return context;
};

